import { IInvoiceDto, ProjectBasicInfoDto } from "@/data/web-api-client";
import { formatCurrency } from "@/helpers/currency";

export default class InvoiceBookmarkReplacer {
    public static Replace(formdata: any, invoice: IInvoiceDto, project: ProjectBasicInfoDto) {

        let contact = null;
        if (invoice) {
            if (invoice.customerContact) {
                contact = invoice.customerContact;
            } else if (invoice.customer) {
                contact = invoice.customer;
            }
        }

        formdata.content = formdata.content.replace(
            "#CurrentDate",
            new Date().toLocaleDateString()
        );

        if (invoice.dueDate) {
            formdata.content = formdata.content.replace(
                "#DaysOverdue",
                Math.round(
                    (new Date().getTime() - new Date(invoice.dueDate).getTime()) /
                    (24 * 3600 * 1000)
                )
            );
        }

        formdata.content = formdata.content.replace(
            "#Date",
            new Date(invoice.date!) ? new Date(invoice.date!).toLocaleDateString() : ""
        );

        formdata.content = formdata.content.replace(
            "#DueDate",
            new Date(invoice.dueDate!) ? new Date(invoice.dueDate!).toLocaleDateString() : ""
        );

        formdata.content = formdata.content.replace(
            "#Total",
            invoice.total ? formatCurrency(invoice.total) : ""
        );

        if (
            formdata.content.indexOf("#WarfAddress") !== -1 &&
            project &&
            project.address
        ) {
            formdata.content = formdata.content.replace(
                "#WarfAddress",
                `${project.address.addressline1}, ${project.address.zip} ${project.address.city}`
            );
        }

        formdata.content = formdata.content.replace(
            "#WarfAddress",
            invoice.total ? formatCurrency(invoice.total) : ""
        );

        while (formdata.content.indexOf("#Name") !== -1) {
            formdata.content = formdata.content.replace(
                "#Name",
                contact ? contact.displayName : ""
            );
        }

        formdata.content = formdata.content.replace(
            "#DocumentNumber",
            invoice.documentNumber
        );

        // while ((formdata.content as string).indexOf('#DocumentNumber') !== -1) {

        // }

        formdata.subject = formdata.subject.replace(
            "#DocumentNumber",
            invoice.documentNumber
        );

        // while ((formdata.subject as string).indexOf('#DocumentNumber') !== -1) {

        // }

        if (contact && contact.type === "Contact") {
            const splittedName = contact.displayName
                ? contact.displayName.split(" ")
                : null;
            if (splittedName && splittedName.length > 0) {
                const firstname = splittedName[0];
                const lastname = contact.displayName!.replace(firstname, "");

                while (formdata.content.indexOf("#Contact_Firstname") !== -1) {
                    formdata.content = formdata.content.replace(
                        "#Contact_Firstname",
                        firstname
                    );
                }

                while (formdata.content.indexOf("#Contact_Lastname") !== -1) {
                    formdata.content = formdata.content.replace(
                        "#Contact_Lastname",
                        lastname
                    );
                }
            }
        }

        while (formdata.content.indexOf("#Contact_Firstname") !== -1) {
            formdata.content = formdata.content.replace(
                "#Contact_Firstname",
                ""
            );
        }

        while (formdata.content.indexOf("#Contact_Lastname") !== -1) {
            formdata.content = formdata.content.replace(
                "#Contact_Lastname",
                ""
            );
        }

        while (formdata.content.indexOf('#Project_Name') !== -1) {
            formdata.content = formdata.content.replace('#Project_Name', invoice.projectName);
        }
        while (formdata.subject.indexOf('#Project_Name') !== -1) {
            formdata.subject = formdata.subject.replace('#Project_Name', invoice.projectName);
        }

        while (formdata.subject.indexOf('#Project_DocumentNumber') !== -1) {
            formdata.subject = formdata.subject.replace('#Project_DocumentNumber', invoice.projectId);
        }

        while (formdata.content.indexOf('#Project_DocumentNumber') !== -1) {
            formdata.content = formdata.content.replace('#Project_DocumentNumber', invoice.projectId);
        }

        return formdata;
    }
}